// In development, use empty string to leverage React's proxy (package.json: "proxy": "http://localhost:5001")
// This ensures cookies work properly (same-origin requests)
// In production, use the full API URL
const API_BASE = process.env.REACT_APP_API_URL || '';

// Export base URL for utilities that need it
export const API_BASE_URL = API_BASE;

// Google OAuth Client ID
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

export const API = {
  BASE: API_BASE,

  // Auth
  AUTH: `${API_BASE}/api/auth`,

  // Users
  USERS: `${API_BASE}/api/users`,

  // Schedule & Bookings
  SCHEDULE: `${API_BASE}/api/schedule`,
  BOOKINGS: `${API_BASE}/api/bookings`,

  // Balance & Payments
  BALANCE: `${API_BASE}/api/balance`,
  PAYMENT_REQUESTS: `${API_BASE}/api/payment-requests`,
  BANK_REQUISITES: `${API_BASE}/api/bank-requisites`,
  PROMO_CODES: `${API_BASE}/api/promo-codes`,
  STUDY_PLAN: `${API_BASE}/api/study-plan`,

  // Education
  COURSES: `${API_BASE}/api/courses`,
  PROGRAMS: `${API_BASE}/api/programs`,
  LESSONS: `${API_BASE}/api/lessons`,
  PRESENTATIONS: `${API_BASE}/api/presentations`,
  HOMEWORK: `${API_BASE}/api/homework`,
  MODULE_TESTS: `${API_BASE}/api/module-tests`,
  MODULE_CHOICES: `${API_BASE}/api/module-choices`,
  SPECIAL_LESSONS: `${API_BASE}/api/special-lessons`,

  // Groups & Clubs
  GROUPS: `${API_BASE}/api/groups`,
  CLUBS: `${API_BASE}/api/clubs`,

  // Communication
  CHAT: `${API_BASE}/api/chat`,
  NOTIFICATIONS: `${API_BASE}/api/notifications`,
  SUPPORT: `${API_BASE}/api/support`,

  // Shop
  PRODUCTS: `${API_BASE}/api/products`,

  // Teachers
  TEACHER_NOTES: `${API_BASE}/api/teacher-notes`,
  TEACHER_INVITATIONS: `${API_BASE}/api/teacher-invitations`,
  TEACHER_REPORTS: `${API_BASE}/api/teacher-reports`,

  // Admins
  ADMIN_INVITATIONS: `${API_BASE}/api/admin-invitations`,

  // Referrals
  REFERRALS: `${API_BASE}/api/referrals`,

  // Offers
  OFFERS: `${API_BASE}/api/offers`,
  SPECIAL_OFFERS: `${API_BASE}/api/special-offers`,

  // Misc
  REVIEWS: `${API_BASE}/api/reviews`,
  CONSULTATIONS: `${API_BASE}/api/consultations`,
  LESSON_NOTES: `${API_BASE}/api/lesson-notes`,
  MEDIA: `${API_BASE}/api/media`,
  TIMER: `${API_BASE}/api/timer`,
  PRESENTATION_STATE: `${API_BASE}/api/presentation-state`,

  // LiveKit Video
  LIVEKIT: `${API_BASE}/api/livekit`,
  RECORDINGS: `${API_BASE}/api/recordings`,

  // Platform Config
  PLATFORM_CONFIG: `${API_BASE}/api/platform-config`,

  // Stickers
  STICKERS: `${API_BASE}/api/stickers`,

  // Frames (decorative frames that hold image/video content)
  FRAMES: `${API_BASE}/api/frames`,

  // Photos (separate library, same shape as stickers)
  PHOTOS: `${API_BASE}/api/photos`,

  // Exercises
  EXERCISES: `${API_BASE}/api/exercises`,

  // Lesson Games (gamified repetition path)
  LESSON_GAMES: `${API_BASE}/api/lesson-games`,

  // Teacher-authored lessons (own presentation + homework + games,
  // usable as a replacement for a program lesson)
  TEACHER_LESSONS: `${API_BASE}/api/teacher-lessons`,

  // Phone Verification
  PHONE: `${API_BASE}/api/phone`,

  // Account linking + per-child permission requests
  ACCOUNT_LINKS: `${API_BASE}/api/account-links`,
  PERMISSION_REQUESTS: `${API_BASE}/api/permission-requests`,

  // Reader (book reading app)
  READER: `${API_BASE}/api/reader`,
  ADMIN_BOOKS: `${API_BASE}/api/admin/books`,
  ADMIN_TELEGRAM: `${API_BASE}/api/admin/telegram`,
  ADMIN_LESSON_SESSIONS: `${API_BASE}/api/admin/lesson-sessions`,

  // Admin -> teacher edit-permission requests on teacher-authored presentations
  PRESENTATION_EDIT_REQUESTS: `${API_BASE}/api/presentation-edit-requests`,

  // Teacher leaves (vacation, sick, force_majeure)
  TEACHER_LEAVE: `${API_BASE}/api/teacher-leave`,

  // Ken skin catalog + per-user unlocks
  KEN_SKINS: `${API_BASE}/api/ken-skins`,

  // Student points (separate currency from money in BALANCE)
  POINTS: `${API_BASE}/api/points`,
};

export default API;
